import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { brand, nav } from "../mock";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  const handleNav = (e, to) => {
    if (to.startsWith("/#")) {
      e.preventDefault();
      const id = to.split("#")[1];
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }, 250);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0c0d0f]/90 backdrop-blur-xl border-b border-[#26282f]"
          : "bg-transparent"
      }`}
    >
      <div className="af-container flex items-center justify-between h-24 md:h-28">
        {/* Logo lockup (large) */}
        <Link to="/" className="flex items-center group">
          <img
            src={brand.logo}
            alt="August Doors & Windows logo"
            className="h-16 md:h-[5.5rem] w-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {nav.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              onClick={(e) => handleNav(e, item.to)}
              className="hover-underline text-sm font-medium text-[var(--af-text)]/80 hover:text-white transition-colors"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-5">
          <a
            href={brand.phoneHref}
            className="flex items-center gap-2 text-sm text-[var(--af-muted)] hover:text-white transition-colors"
          >
            <Phone size={15} /> {brand.phone}
          </a>
          <Link
            to="/contact"
            className="px-6 py-3 bg-white text-[#0c0d0f] text-sm font-semibold rounded-full hover:bg-[var(--af-blue)] hover:text-white transition-all duration-300"
          >
            Get a Free Quote
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 bg-[#0c0d0f]/98 backdrop-blur-xl border-t border-[#26282f] ${
          open ? "max-h-[520px]" : "max-h-0"
        }`}
      >
        <div className="af-container py-6 flex flex-col gap-2">
          {nav.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              onClick={(e) => handleNav(e, item.to)}
              className="py-3 text-lg text-white/85 border-b border-[#1c1e23]"
            >
              {item.label}
            </Link>
          ))}
          <a
            href={brand.phoneHref}
            className="py-3 text-[var(--af-muted)] flex items-center gap-2"
          >
            <Phone size={16} /> {brand.phone}
          </a>
          <Link
            to="/contact"
            className="mt-2 text-center px-6 py-3 bg-white text-[#0c0d0f] font-semibold rounded-full"
          >
            Get a Free Quote
          </Link>
        </div>
      </div>
    </header>
  );
}
